import { RouterProvider } from 'react-router';
import { router } from './routes';
import { useEffect } from 'react';

// ============================================
// VERSION MANAGEMENT & CACHE BUSTING
// ============================================
const APP_VERSION = '2.5.0'; // Increment this on each major update

// Global check - v2.5
console.log('====================================');
console.log(`APP.TSX LOADED - Version ${APP_VERSION}`);
console.log('Current URL:', window.location.href);
console.log('====================================');

export default function App() {
  console.log(`[App v${APP_VERSION}] Rendering RouterProvider...`);
  
  useEffect(() => {
    // PCI: Cihazda kalmış olabilecek hassas kart verisini her açılışta sil.
    // (Eski sürümler kart bilgisini localStorage'a yazıyordu; ödeme yapan
    // müşteri programa girince bu veriler otomatik temizlenir.)
    try {
      ['cardNumber', 'cardExpireMonth', 'cardExpireYear', 'cardHolderName',
       'cardCvv', 'cardCvc', 'cardPhone', 'cardAddress', 'pendingCardData']
        .forEach((k) => localStorage.removeItem(k));
    } catch { /* localStorage erişilemiyorsa yok say */ }

    // Check version and clear cache if needed
    const storedVersion = localStorage.getItem('app_version');
    
    if (storedVersion !== APP_VERSION) {
      console.log(`🔄 Version mismatch detected: ${storedVersion} → ${APP_VERSION}`);
      console.log('🧹 Clearing cache and reloading...');
      
      // Clear localStorage (except tenant_id and access_token)
      const tenantId = localStorage.getItem('tenant_id');
      const accessToken = localStorage.getItem('access_token');
      const userId = localStorage.getItem('user_id');
      const userName = localStorage.getItem('user_name');
      const userRole = localStorage.getItem('user_role');
      
      localStorage.clear();
      
      // Restore critical auth data
      if (tenantId) localStorage.setItem('tenant_id', tenantId);
      if (accessToken) localStorage.setItem('access_token', accessToken);
      if (userId) localStorage.setItem('user_id', userId);
      if (userName) localStorage.setItem('user_name', userName);
      if (userRole) localStorage.setItem('user_role', userRole);
      
      // Set new version
      localStorage.setItem('app_version', APP_VERSION);
      
      // Clear service worker cache if exists
      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
      }
      
      // Force reload to get fresh assets
      console.log('✅ Cache cleared, reloading page...');
      window.location.reload();
    } else {
      console.log(`✅ App version up to date: ${APP_VERSION}`);
    }
  }, []);
  
  try {
    return <RouterProvider router={router} />;
  } catch (error) {
    console.error('[App] Error rendering router:', error);
    return (
      <div style={{ padding: '20px', color: 'red', fontFamily: 'monospace' }}>
        <h1>Application Error</h1>
        <p>Check browser console for details</p>
        <pre>{String(error)}</pre>
      </div>
    );
  }
}